const input = [
    {
        id: 1,
        name: "Farmacia",
    },
    {
        id: 2,
        name: "Ambulatorio",
    },
]

export const sortConsumos = (items, key, direction = "asc") => {
    if (!key) return [...items];

    return [...items].sort((left, right) => {
        let leftValue = left?.[key];
        let rightValue = right?.[key];

        if (leftValue === null || leftValue === undefined || leftValue === "") return 1;
        if (rightValue === null || rightValue === undefined || rightValue === "") return -1;
        if (key === "fecha") {
            leftValue = Date.parse(leftValue);
            rightValue = Date.parse(rightValue);
        }

        const comparison = typeof leftValue === "number" && typeof rightValue === "number"
            ? leftValue - rightValue
            : String(leftValue).localeCompare(String(rightValue), "es", { numeric: true });
        return direction === "asc" ? comparison : -comparison;
    });
};

export const DataColumns = [
    {
        accessorKey: "fecha",
        header: "Fecha"
    },
    {
        accessorKey: "consumoId",
        header: "ID",
    },
    {
        accessorKey: "afiliadoId",
        header: "Asociado",
    },
    {
        accessorKey: "prestadorId",
        header: "Prestador",
    },
    {
        accessorKey: "tipoConsumoId",
        header: "Tipo",
        cell: ({ row }) => {
            const tipoEncontrado = input.find(x => x.id === row.getValue("tipoConsumoId"));

            return tipoEncontrado?.name || `Desconocido (${row.getValue("tipoConsumoId")})`;
        }
    },
    {
        accessorKey: "cantidadSolicitada",
        header: "Solicitada",
    },
    {
        accessorKey: "cantidadAutorizada",
        header: "Autorizada",
    },
    {
        accessorKey: "copago",
        header: "Copago",
    },
]
